module.exports = __webpack_public_path__ + "img/Flag_of_Guinea-Bissau.6c1ff733.svg";